var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-email",
    d: "M18.242,61H1.758A1.747,1.747,0,0,0,0,62.731V74.269A1.747,1.747,0,0,0,1.758,76H18.242A1.747,1.747,0,0,0,20,74.269V62.731A1.747,1.747,0,0,0,18.242,61ZM18,62.154l-7.962,7.84-8.031-7.84ZM1.172,74.03V62.964l5.644,5.509ZM2,74.846l5.647-5.56,1.979,1.932a.592.592,0,0,0,.827,0l1.929-1.9L18,74.846Zm16.828-.816L13.211,68.5l5.617-5.53Z",
    transform: "translate(0 -61)",
    fill: "#1b214a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.bfccaa71e853249d3a7c0158493e4446.svg";
export { ForwardRef as ReactComponent };